import { useState } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import InputField from "../../atoms/InputField";
import TemplateForm from "../../atoms/TemplateForm";
import { UPDATE_GASTOS } from "../../../api/apiGastos";

const GastosUpdateFile = ({ gasto ,refetch, onClose }) => {
    const [ , setArchivo] = useState({ file: null });

    const initialValues = {
        file: null,
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            await UPDATE_GASTOS(gasto.id, values);
            refetch();
            onClose();
        } catch (error) {
            console.error(error);
        } finally {
            setSubmitting(false);
        }
    };

    const validationSchema = Yup.object({
        file: Yup.mixed().required("La factura es obligatoria"),
    });

    return (
        <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={validationSchema}>
        {({ values, isSubmitting, setFieldValue }) => (
            <TemplateForm
                fields={
                    <>
                        <InputField
                            name="file"
                            label="Factura"
                            type="file"
                            onChange={(e) => {
                                const file = e.currentTarget.files?.[0] || null;
                                setFieldValue("file", file);
                                setArchivo((prev) => ({ ...prev, file: file }));
                            }}
                        />
                    </>
                }
                isSubmitting={isSubmitting}
                textButton="Aceptar"
            />
        )}
        </Formik>
    )
};

export default GastosUpdateFile;